import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_agent/policies')({
  component: PoliciesLayout,
});

function PoliciesLayout() {
  return <Outlet />;
}
